function escapeHtml(text: string): string {
   return String(text)
      .replace(/&/g, "&amp;")
      .replace(/</g, "&lt;")
      .replace(/>/g, "&gt;")
      .replace(/"/g, "&quot;");
}

function copyPlainTextFallback(plainText: string): boolean {
   const textArea = document.createElement("textarea");
   textArea.value = plainText;
   textArea.style.position = "fixed";
   textArea.style.opacity = "0";
   document.body.appendChild(textArea);
   textArea.focus();
   textArea.select();

   let copied = false;
   try {
      copied = document.execCommand("copy");
   } catch {
      copied = false;
   }

   document.body.removeChild(textArea);
   return copied;
}

export async function copyUrlAsLink(url: string, displayText?: string): Promise<boolean> {
   const trimmedUrl = String(url || "").trim();
   if (!trimmedUrl) {
      return false;
   }

   if (document.hasFocus && !document.hasFocus()) {
      window.focus();
   }

   const plainText = `${trimmedUrl}\n`;
   const linkText = String(displayText || "").trim() || trimmedUrl;
   const htmlText = `<a href="${escapeHtml(trimmedUrl)}">${escapeHtml(linkText)}</a>`;

   if (navigator.clipboard?.write) {
      try {
         await navigator.clipboard.write([
            new ClipboardItem({
               "text/plain": new Blob([plainText], { type: "text/plain" }),
               "text/html": new Blob([htmlText], { type: "text/html" }),
            }),
         ]);
         return true;
      } catch {
         // Fall through to plain-text copy.
      }
   }

   if (navigator.clipboard?.writeText) {
      try {
         await navigator.clipboard.writeText(plainText);
         return true;
      } catch {
         // Fall through to execCommand fallback.
      }
   }

   return copyPlainTextFallback(plainText);
}
